import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0bea65bf")

_pushScopeId("data-v-0bea65bf")
const _hoisted_1 = { class: "ui__baseInfo_main" }
const _hoisted_2 = { class: "ui__baseInfo_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__baseInfo_title" }, " 基础信息 ", -1)
const _hoisted_4 = { class: "vin-msg" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "vin-msg-label" }, "车架号", -1)
const _hoisted_6 = { class: "vin-msg-value" }
const _hoisted_7 = { class: "ui__baseInfo_content" }
const _hoisted_8 = { class: "ui_baseInfo_content_item_label" }
const _hoisted_9 = { class: "ui_baseInfo_content_item_value" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.state.vin), 1)
      ]),
      _createVNode("div", _hoisted_7, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.dataList, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "ui_baseInfo_content_item",
            key: item.name
          }, [
            _createVNode("div", _hoisted_8, _toDisplayString(item.fieldName), 1),
            _createVNode("div", _hoisted_9, [
              (item.fieldValue)
                ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(item.fieldValue), 1))
                : (_openBlock(), _createBlock("span", _hoisted_11, "-"))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
})